/**
 * Fix header height when top menu is active
 */
window.addEventListener('breakpointChange', () => {
	setTimeout(() => {
		adjustHeaderOffsets();
	}, 100);
});

const adjustHeaderOffsets = () => {
	const topMenu = document.querySelector('.top-menu-wrapper');
	const siteHeader = document.querySelector('.main-menu-wrapper');
	let styles = getComputedStyle(document.documentElement);

	if (topMenu && styles.getPropertyValue('--strl-header-height')) {
		document.documentElement.style.setProperty(
			'--strl-header-height',
			siteHeader.offsetHeight + topMenu.offsetHeight + 'px'
		);
	} else if (styles.getPropertyValue('--strl-header-height')) {
		document.documentElement.style.setProperty(
			'--strl-header-height',
			siteHeader.parentElement.offsetHeight + 'px'
		);
	}

	if (styles.getPropertyValue('--strl-m-header-height')) {
		document.documentElement.style.setProperty(
			'--strl-m-header-height',
			siteHeader.parentElement.offsetHeight + 'px'
		);
	}
};
